export { headSnippet, noscriptSnippet } from './head-snippet';
export { init, showPreferences } from './init';
export { normalizeConfig } from './types';
export type { ConsentConfig, ConsentColors, ConsentCategories } from './types';
